import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  const productCategories = categories.slice(0, 4);
  const guideCategories = categories.slice(4, 8);
  const moreCategories = categories.slice(8, 14);

  return (
    <footer className="bg-background-100 border-t border-background-200/70">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="py-14 md:py-16">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
            <div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4">Przewodniki</h4>
              <div className="w-8 h-px bg-primary-400 mb-4"></div>
              <ul className="space-y-2.5">
                {guideCategories.map((cat) => (
                  <li key={cat.name}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4">Produkty</h4>
              <div className="w-8 h-px bg-primary-400 mb-4"></div>
              <ul className="space-y-2.5">
                {productCategories.map((cat) => (
                  <li key={cat.name}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4">Więcej kategorii</h4>
              <div className="w-8 h-px bg-primary-400 mb-4"></div>
              <ul className="space-y-2.5">
                {moreCategories.map((cat) => (
                  <li key={cat.name}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold text-foreground-950 mb-4">O nas</h4>
              <div className="w-8 h-px bg-primary-400 mb-4"></div>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">
                USFansSpreadsheet to Twój kompletny przewodnik po arkuszach kalkulacyjnych. Oferujemy rzetelne porównania, rankingi i analizy bezpieczeństwa.
              </p>
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer whitespace-nowrap"
              >
                Odwiedź Kaspreadsheet
                <i className="ri-arrow-right-up-line"></i>
              </a>
            </div>
          </div>
        </div>

        <div className="py-6 border-t border-background-200/70 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div>
            <span className="text-2xl font-bold font-heading text-foreground-950">USFans</span>
            <span className="text-2xl font-bold font-heading text-primary-500 ml-1">Spreadsheet</span>
            <div className="w-10 h-px bg-primary-400 mt-2"></div>
          </div>

          <p className="text-xs text-foreground-500">
            &copy; 2026 USFansSpreadsheet. Wszelkie prawa zastrzeżone.
          </p>

          <div className="flex items-center gap-3">
            <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="w-9 h-9 rounded-full bg-secondary-100 flex items-center justify-center text-secondary-700 hover:bg-secondary-200 transition-colors cursor-pointer">
              <i className="ri-global-line text-sm"></i>
            </a>
            <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="w-9 h-9 rounded-full bg-secondary-100 flex items-center justify-center text-secondary-700 hover:bg-secondary-200 transition-colors cursor-pointer">
              <i className="ri-shopping-bag-line text-sm"></i>
            </a>
            <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="w-9 h-9 rounded-full bg-secondary-100 flex items-center justify-center text-secondary-700 hover:bg-secondary-200 transition-colors cursor-pointer">
              <i className="ri-star-line text-sm"></i>
            </a>
            <a href="https://kaspreadsheet.com/" target="_blank" rel="noopener nofollow" className="w-9 h-9 rounded-full bg-secondary-100 flex items-center justify-center text-secondary-700 hover:bg-secondary-200 transition-colors cursor-pointer">
              <i className="ri-heart-line text-sm"></i>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}